/**
 * 初始化State
 * @type {{}}
 */
const initialState = {
    form : {
        loginForm : {},//登录表单
        registerForm : {},//注册表单
        resetPassword : {},
        retrieveMobile : {}
    },
}

const _update = ( state, payload ) => {

    let form = state.form[ payload.form ] || {};

    for ( let [ , field ] of Object.entries( form ) ) {
        if ( field.name === payload.name ) {
            Object.assign( field, payload );
        }
    }
}

export default ( state = initialState, action ) => {

    let payload = action.payload;

    switch ( action.type ) {

        case "initialForm"://初始化表单

            state.form[ payload.name ] = payload.form;

            return state;

        case "update"://更新表单字段

            _update( state, payload );

            return state;



        default:

            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/form-reducer.js